import React, { useCallback } from 'react';
import styled from 'styled-components/macro';

import { viewport } from '../common/config';
import useMediaStore from '../common/store/useMediaStore';
import useModalStore from '../modal/Disclaimer/useModalStore';

export const Wrapper = styled.div(({ $bottom, $color }: {
  $bottom: number,
  $color: string
}) => `
  position: absolute;
  z-index: 4;
  left: 50%;
  bottom: ${$bottom}vh;

  width: 98%;
  transform: translateX(-50%);

  display: none;
  justify-content: end;

  &, & p {
    font-size: 12rem;
    color: ${$color};
    white-space: pre;
  }

  & a {
    font-size: 12rem;
    color: #5499C7;
    text-decoration: underline;
    cursor: pointer;
  }

  @media screen and (min-width: ${viewport.md}){
    justify-content: space-between;

    &, & p { white-space: normal }
  }

  @media screen and (min-height: 42em) {
    display: flex;
  }
`);

const Left = styled.div`
  text-align: start;
`;

const Right = styled.div`
  text-align: end;
`;

const FooterLinks = React.forwardRef(({ bottom, color }: {
  bottom: number, //vh
  color: string
}, ref: React.ForwardedRef<HTMLDivElement>
) => {

  const open = useModalStore(useCallback(state => state.open, []));
  const md = useMediaStore(useCallback(state => state.md, []));

  return (
    <Wrapper
      ref={ref}
      $bottom={bottom}
      $color={color}
    >
      {md &&
        <Left>
          <p>Please do not share with people below drinking age.</p>
          <a href="http://www.responsibledrinking.org/" target="_blank">Please drink responsibly</a>
        </Left>
      }

      <Right>
        <p>{"©2019 Carlsberg Group. All Rights Reserved.\nJ.C. Jacobsens Gade 1,DK-1799 Copenhagen"}</p>
        <a href="https://www.somersby.com/en/homepage" target="_blank">Official website</a>
        {" | "}
        <a onClick={() => open && open()}>Disclaimer</a>
      </Right>

    </Wrapper>
  );
});

export default FooterLinks;